export const ME_V2_TAB = {
  ACCOUNT: 'account',
  COUPON: 'coupon',
  WALLET: 'wallet',
  ADDRESS: 'address',
  INVOICE_CARRIER: 'invoiceCarrier',
  COMPANY_INVOICE: 'companyInvoice',
  PREFERENCE: 'preference',
} as const

export type TMeV2Tab = (typeof ME_V2_TAB)[keyof typeof ME_V2_TAB]
